import { Controller } from "@hotwired/stimulus"
import Lenis from "lenis"

export default class extends Controller {
	static targets = ["wrapper", "content"]

	connect() {
		this.start()
	}

	disconnect() {
		this.destroy()
	}

	start() {
		this.lenis = new Lenis({
			wrapper: this.wrapperTarget,
			content: this.contentTarget,
			eventsTarget: document.body,

			orientation: "horizontal",
			gestureOrientation: "both",
			infinite: !window.matchMedia("(pointer: coarse)").matches,

			duration: 1.2,
			easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),

			smoothWheel: true,
			wheelMultiplier: 1,      // Scroll speed multiplier
			touchMultiplier: 2,      // Touch scroll speed

			autoRaf: true
		})
	}

	destroy() {
		this.lenis.destroy()
		delete this.lenis
	}
}
